<template>
    <div class="row m-0 fullsize w-100 text-dark"	id="loader">
        <div class="m-auto text-center">
            <div class="spinner-border fa-3x "> </div>			
            <h1><em> Sorry I fell asleep <i class="fa fa-bed" aria-hidden="true"></i> </em></h1>
            <!-- <p class="zzz h3 "> zzzz </p> -->
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>